import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router';
// import { usePermissionStore } from '@/stores/permissionStore';
// const permissionStore = usePermissionStore()
// console.log([permissionStore])
const router = createRouter({
    // history: createWebHistory(import.meta.env.BASE_URL),
    history: createWebHashHistory(import.meta.env.BASE_URL),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { top: 0 };
        }
    },
    linkActiveClass: 'active',
    linkExactActiveClass: 'active',
    base: import.meta.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'Layout',
            component: () => import('@/layouts/index.vue'),
            redirect: '/index',
            // children: teamRouter
            children: [
                {
                    path: '/index',
                    name: 'Index',
                    meta: {
                        title: '首页'
                    },
                    component: () => import('../views/index.vue')
                },
                {
                    path: '/class',
                    name: 'Class',
                    meta: {
                        title: '招生列表'
                    },
                    component: () => import('../views/class/index.vue')
                },
                {
                    path: '/class-apply',
                    name: 'ClassApply',
                    meta: {
                        title: '招生介绍'
                    },
                    component: () => import('../views/class/apply.vue')
                },
                {
                    path: '/class-base-info',
                    name: 'ClassBaseInfo',
                    meta: {
                        title: '基本信息'
                    },
                    component: () => import('../views/class/step/base-info.vue')
                },
                {
                    path: '/class-experience-info',
                    name: 'ClassExperienceInfo',
                    meta: {
                        title: '经历信息'
                    },
                    component: () => import('../views/class/step/experience-info.vue')
                },
                {
                    path: '/class-plan-info',
                    name: 'ClassPlanInfo',
                    meta: {
                        title: '进修计划'
                    },
                    component: () => import('../views/class/step/plan-info.vue')
                },
                {
                    path: '/class-apply-print',
                    name: 'ClassApplePrint',
                    meta: {
                        title: '审批表打印'
                    },
                    component: () => import('../views/class/step/apply-print.vue')
                },
                {
                    path: '/class-upload-file',
                    name: 'ClassUploadFile',
                    meta: {
                        title: '上传证书'
                    },
                    component: () => import('../views/class/step/upload-file.vue')
                },
                {
                    path: '/class-status',
                    name: 'ClassStatus',
                    meta: {
                        title: '上传证书'
                    },
                    component: () => import('../views/class/step/class-status.vue')
                },
                {
                    path: '/apply',
                    name: 'Apply',
                    meta: {
                        title: '我的申请'
                    },
                    component: () => import('../views/apply/index.vue')
                },
                {
                    path: '/evaluate',
                    name: 'Evaluate',
                    meta: {
                        title: '进修评价'
                    },
                    component: () => import('../views/evaluate/index.vue')
                },
                {
                    path: '/work',
                    name: 'Work',
                    meta: {
                        title: '考勤管理'
                    },
                    component: () => import('../views/work/index.vue')
                },
                {
                    path: '/payment-desc',
                    name: 'PaymentDesc',
                    meta: {
                        title: '缴费指南'
                    },
                    component: () => import('../views/payment-desc.vue')
                }
            ]
        },
        {
            path: '/login',
            name: 'Login',
            meta: {
                not_auth: true,
                title: '登录'
            },
            component: () => import('../views/login/index.vue')
        },
        {
            path: '/register',
            name: 'Register',
            meta: {
                not_auth: true,
                title: '注册'
            },
            component: () => import('../views/register/index.vue')
        },
        {
            path: '/reset-password',
            name: 'ResetPassword',
            meta: {
                not_auth: true,
                title: '找回密码'
            },
            component: () => import('../views/reset-password.vue')
        },
        {
            path: '/:carchAll(.*)',
            name: '404',
            component: () => import('../views/404.vue')
        }
    ]
});

export default router;
